











import Vue from 'vue';
import InlineSVG from 'vue-inline-svg';
import TIcons from '@/types/TIcons';

interface IChristmasCalendarToggleCircle {
  presentIconPath: string;
}

export default Vue.extend({
  name: `ChristmasCalendarToggleCircle`,
  components: { InlineSVG },
  data(): IChristmasCalendarToggleCircle {
    return {
      presentIconPath: TIcons.christmasCalendar.present,
    };
  },
  methods: {
    showCalendar(): void {
      this.$emit(`show:calendar`);
    },
  },
});
